<template>
  <div>
    <div class="text-center">
      <h2 class="font-weight-light">Payments & subscriptions</h2>
    </div>

    <v-card class="mx-auto mt-5" max-width="840" outlined>
      <v-list-item three-line>
        <v-list-item-content>
          <v-list-item-title class="headline mb-1"
            >Payment methods</v-list-item-title
          >
          <v-list-item-subtitle></v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-card-text>
        <v-row>
          <v-col cols="4"></v-col>
          <v-col cols="8"></v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn exact to="payment-methods" text color="blue accent-3"
          >Manage payment methods</v-btn
        >
      </v-card-actions>
    </v-card>
    <v-card class="mx-auto mt-5" max-width="840" outlined>
      <v-list-item three-line>
        <v-list-item-content>
          <v-list-item-title class="headline mb-1">Purchases</v-list-item-title>
          <v-list-item-subtitle></v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-card-text>
        <v-row>
          <v-col cols="4"></v-col>
          <v-col cols="8"></v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-btn exact to="purchases" text color="blue accent-3">View purchases</v-btn>
      </v-card-actions>
    </v-card>

    <v-card class="mx-auto mt-5" max-width="840" outlined>
      <v-list-item three-line>
        <v-list-item-content>
          <v-list-item-title class="headline mb-1"
            >Subscriptions</v-list-item-title
          >
          <v-list-item-subtitle></v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-card-text>
        <v-row>
          <v-col cols="4"></v-col>
          <v-col cols="8"></v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn text color="blue accent-3">Manage subscriptions</v-btn>
      </v-card-actions>
      <v-overlay :absolute="absolute" value="true">
        <h2>Coming soon</h2>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "PaymentsAndSubscriptions",
  data() {
    return {
      drawer: null,
      absolute: true,
    };
  },
};
</script>
